import { type ReactNode } from 'react';

import { cn } from './cn.ts';

/** A keyboard shortcut, shown as keys: `Ctrl+Shift+P` → Ctrl Shift P. */
export function Kbd({ children, className }: { children: ReactNode; className?: string }) {
  const keys = typeof children === 'string' ? children.split('+') : [children];
  return (
    <span className={cn('inline-flex items-center gap-0.5', className)}>
      {keys.map((key, i) => (
        <kbd
          key={i}
          className="min-w-5 rounded border border-border bg-surface-sunken px-1 py-px text-center font-sans text-[10px] leading-4 text-fg-muted"
        >
          {key}
        </kbd>
      ))}
    </span>
  );
}
